import React, { useState } from "react";
import Nav from './nav.jsx';
import Home from './home';
import About from './aboutus';

window.onscroll = function() {myFunction()};

function myFunction() {
  if (document.body.scrollTop > 330 || document.documentElement.scrollTop > 330) {
    document.getElementById("s4").style.display = "block";
    
  } 
  else{
    document.getElementById("s4").style.display = "none";

  }

  if (document.body.scrollTop > 700 || document.documentElement.scrollTop > 700) 
   {
    document.getElementById("s5").style.display = "block";
  }
  else
  {
    document.getElementById("s5").style.display = "none";
  }
  if (document.body.scrollTop > 900 || document.documentElement.scrollTop > 900) 
  {
   document.getElementById("s6").style.display = "block";
 }
 else
 {
  document.getElementById("s6").style.display = "none";
 }


 

    
}


function App() {
  
  return (
  
      <div >
       <div id="ssvg">
         <img className="back " id = "s1" src="../images/thinking.svg"></img>
         <img className="back-2 " id = "s2" src="../images/taking.svg"></img>
         <img className="back-3 " id = "s3" src="../images/note-taking.svg"></img>
         <img className="back-4 " id = "s4" src="../images/bulb.svg"></img>
         <img className="back-5 " id = "s5" src="../images/write.svg"></img>
         <img className="back-6" id = "s6" src="../images/science.svg"></img>
       </div>



        <div className="app">
           <Nav />
           <Home />
           <About />
        </div> 
      </div>
  
   );
}

export default App;


